import React, { useState, useCallback, useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { GoogleLoginButton } from '../google-login-button'
import { image } from '../../../../lib/image'

import { useUsersApi } from '../../../../store'

import { styles } from './styles'

// Once per module: makeStyles called inside a render built a new JSS sheet,
// with new class names, on every render (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

const SignUpOverflow = React.memo(props => {
  const classes = useStyles()
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [mobile, setMobile] = useState('')
  const [password, setPassword] = useState('')
  // Explicit opt-in for WhatsApp marketing - default off, tick to subscribe.
  // Email marketing is unchanged (default opt-in at signup, unsubscribe via
  // link in every email - industry standard).
  const [optedInWhatsappMarketing, setOptedInWhatsappMarketing] = useState(false)
  const { apiUserSignUp } = useUsersApi()

  const handleFirstNameChange = useCallback(event => setFirstName(event.target.value), [setFirstName])
  const handleLastNameChange = useCallback(event => setLastName(event.target.value), [setLastName])
  const handleEmailChange = useCallback(event => setEmail(`${event.target.value}`.toLowerCase()), [setEmail])
  const handleMobileChange = useCallback(event => setMobile(event.target.value), [setMobile])
  const handlePasswordChange = useCallback(event => setPassword(event.target.value), [setPassword])
  const handleOptedInWhatsappChange = useCallback(event => setOptedInWhatsappMarketing(event.target.checked), [])
  const handleSubmit = useCallback(
    event => {
      event.preventDefault()
      apiUserSignUp({
        firstName, lastName, email, mobile, password,
        optedInEmailMarketing: true,                          // default opt-in for email
        optedInWhatsappMarketing: optedInWhatsappMarketing    // explicit opt-in only
      })
    },
    [apiUserSignUp, firstName, lastName, email, mobile, password, optedInWhatsappMarketing]
  )

  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className="signup-background">
      <div className="signup-container">
        <div className="signup-content">
          <NavLink to="/">
            <img width="208" height="41" src={image('./wordmark.svg')} alt="GoWashMyCar" />
          </NavLink>

          <h2 className="signup-title">A car wash. Delivered to your door</h2>

          <form noValidate className="signup-form" onSubmit={handleSubmit}>
            <GoogleLoginButton title="Continue with Google" />

            <div className="signup-form-horizontal-row">or</div>

            <div className="signup-form-names">
              <input className="signup-form-firstname" id="fName" name="fname" autoFocus placeholder="First Name" onChange={handleFirstNameChange} />
              <input className="signup-form-lastname" id="lName" name="lName" placeholder="Last Name" onChange={handleLastNameChange} />
            </div>
            <input className="signup-form-phone" id="phone" name="phone" autoComplete="tel" placeholder="Mobile phone" onChange={handleMobileChange} />
            <p className="signup-form-helper">We'll send booking updates on WhatsApp.</p>
            <input className="signup-form-email" id="email" name="email" autoComplete="email" placeholder="Email address" onChange={handleEmailChange} />
            <input
              className="signup-form-password"
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              placeholder="Password"
              onChange={handlePasswordChange}
            />
            <input className="signup-form-submit" type="submit" value="Continue" />
          </form>

          <div className="signup-extra">
            <input name="optInWhatsappMarketing" id="optInWhatsappMarketing" type="checkbox" checked={optedInWhatsappMarketing} onChange={handleOptedInWhatsappChange} />
            <label htmlFor="optInWhatsappMarketing">Send me £25 refer-a-friend rewards, exclusive offers, and wash reminders on WhatsApp. Reply STOP anytime.</label>
          </div>

          <p className="signup-form-question">Already have an account?</p>
          <Link to="/user/sign_in" className="signup-form-create">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  )
})

export default SignUpOverflow
